import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

interface WorkCardProps {
  work: Work;
  actressNames: string[];
}

export default function WorkCard({ work, actressNames }: WorkCardProps) {
  return (
    <Link
      to={`/detail/work/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200">
        <div className="aspect-[2/3] w-full">
          <img
            src={work.cover}
            alt={`${work.title} 影视作品封面`}
            title={`${work.title} 日本女优影视作品介绍`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
          />
        </div>
        <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2 py-0.5 font-label text-[11px] text-foreground-800">
          {work.type}
        </span>
        <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-foreground-950/75 px-2 py-0.5 font-label text-[11px] text-accent-400">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="clamp-2 mt-1 font-label text-xs text-foreground-500">
          {work.year} 年 · 导演 {work.director}
        </p>
        <p className="clamp-2 mt-2 text-sm text-foreground-700">主演：{actressNames.join("、")}</p>
      </div>
    </Link>
  );
}